module.exports = {
        srcSet: __webpack_public_path__ + "static/media/phone-400.dfa9e3af.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/phone-400.dfa9e3af.webp",width: 400,height: 399}],
        src: __webpack_public_path__ + "static/media/phone-400.dfa9e3af.webp",
        toString: function(){return __webpack_public_path__ + "static/media/phone-400.dfa9e3af.webp"},
        
        width: 400,
        height: 399
      }